import { clearLocalStoragePlanning } from "data/cache/localstorage-cache"
import { getEnv } from "helper/window-helper"

/** Remove tokens e preferências de sessão (mesmo conjunto do header "Sair"). */
export function clearAuthLocalStorage(): void {
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_TOKEN_USER_LOGIN"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_TOKEN_USER_CHANGE"))
    localStorage.removeItem("is-super-user")
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_INFO_CHECK"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_VIEW_COMMUNIQUE"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_COLUMS_ANALYTICAL"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_COLUMS_MANAGERIAL"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_COLUMS_SYNTHETIC"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_COLUMS_EQUALIZATION"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_COLUMS_ACTIVE_CAMPAIGN"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_PLANNING_ANALYTICAL"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_PLANNING_SYNTHETIC"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_PLANNING_EQUALIZATION"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_PLANNING_INDICATOR"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_PLANNING_MENAGERIAL"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_PLANNING_SCRAP"))
    localStorage.removeItem(getEnv("REACT_APP_LOCALSTORAGE_PLANNING_ACTIVE_CAMPAIGN"))
    clearLocalStoragePlanning()
}
